v-radio-group(
  :model-value="modelValue"
  @update:model-value="updateValue"
  :color="radioColor"
  v-bind="$attrs"
)
  slot
